import styled from 'styled-components';

export const ImageStyles = styled.img`
  display: flex;
  width: 80%;
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.1);
`